module.exports = __webpack_public_path__ + "static/media/yasuo.8b3c5ce1.png";